import React, { useState } from 'react';
import { Terminal, Github, Twitter, Linkedin, Mail, Instagram } from 'lucide-react';
import { PolicyModal } from './PolicyModal';
export const Footer = () => {
  const [isPolicyOpen, setIsPolicyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const privacyContent = <div data-id="element-68">
      <p className="mb-4" data-id="element-69">Last updated: January 1, 2025</p>
      <h3 className="text-xl font-semibold mb-3" data-id="element-70">1. Information Collection</h3>
      <p className="mb-4" data-id="element-71">
        We collect information that you provide directly to us, including when
        you create an account, use our services, or communicate with us. This
        may include:
      </p>
      <ul className="list-disc ml-6 mb-4" data-id="element-72">
        <li data-id="element-73">Name and contact information</li>
        <li data-id="element-74">System diagnostic data</li>
        <li data-id="element-75">Usage statistics and preferences</li>
        <li data-id="element-76">Technical information about your devices</li>
      </ul>
      <h3 className="text-xl font-semibold mb-3" data-id="element-77">2. Use of Information</h3>
      <p className="mb-4" data-id="element-78">We use the collected information to:</p>
      <ul className="list-disc ml-6 mb-4" data-id="element-79">
        <li data-id="element-80">Provide and improve our AI support services</li>
        <li data-id="element-81">Personalize your experience</li>
        <li data-id="element-82">Analyze and optimize our systems</li>
        <li data-id="element-83">Communicate with you about our services</li>
      </ul>
      <h3 className="text-xl font-semibold mb-3" data-id="element-84">3. Data Security</h3>
      <p className="mb-4" data-id="element-85">
        We implement appropriate technical and organizational measures to
        protect your personal information against unauthorized access,
        alteration, disclosure, or destruction.
      </p>
      <h3 className="text-xl font-semibold mb-3" data-id="element-86">4. Updates to This Policy</h3>
      <p data-id="element-87">
        We may update this Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page.
      </p>
    </div>;
  const termsContent = <div data-id="element-88">
      <p className="mb-4" data-id="element-89">Last updated: January 1, 2025</p>
      <h3 className="text-xl font-semibold mb-3" data-id="element-90">1. Acceptance of Terms</h3>
      <p className="mb-4" data-id="element-91">
        By accessing and using TechAIgent's services, you agree to be bound by
        these Terms of Service and all applicable laws and regulations.
      </p>
      <h3 className="text-xl font-semibold mb-3" data-id="element-92">2. Service Description</h3>
      <p className="mb-4" data-id="element-93">
        TechAIgent provides AI-powered technical support services. We reserve
        the right to modify, suspend, or discontinue any aspect of our services
        at any time.
      </p>
      <h3 className="text-xl font-semibold mb-3" data-id="element-94">3. User Responsibilities</h3>
      <p className="mb-4" data-id="element-95">You agree to:</p>
      <ul className="list-disc ml-6 mb-4" data-id="element-96">
        <li data-id="element-97">Provide accurate information</li>
        <li data-id="element-98">Maintain the security of your account</li>
        <li data-id="element-99">Use the services in compliance with all applicable laws</li>
        <li data-id="element-100">Not interfere with the proper working of the services</li>
      </ul>
      <h3 className="text-xl font-semibold mb-3" data-id="element-101">4. Limitation of Liability</h3>
      <p className="mb-4" data-id="element-102">
        TechAIgent shall not be liable for any indirect, incidental, special,
        consequential, or punitive damages resulting from your use or inability
        to use the service.
      </p>
      <h3 className="text-xl font-semibold mb-3" data-id="element-103">5. Changes to Terms</h3>
      <p data-id="element-104">
        We reserve the right to modify these terms at any time. Continued use of
        our services following any modifications constitutes your acceptance of
        the updated terms.
      </p>
    </div>;
  return <footer className="bg-slate-900 text-slate-300" data-id="element-105">
      <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8" data-id="element-106">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-107">
          <div className="col-span-1 md:col-span-2" data-id="element-108">
            <div className="flex items-center mb-4" data-id="element-109">
              <Terminal className="h-8 w-8 text-indigo-400" data-id="element-110" />
              <span className="ml-2 text-xl font-bold text-white" data-id="element-111">
                TechAIgent
              </span>
            </div>
            <p className="mb-4" data-id="element-112">
              The next generation of autonomous AI tech support, designed to
              solve problems before you even notice them.
            </p>
            <div className="space-y-3" data-id="element-113">
              <a href="mailto:info@TechAIgent.com" className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors" data-id="element-114">
                <Mail className="h-5 w-5" data-id="element-115" />
                <span data-id="element-116">info@TechAIgent.com</span>
              </a>
              <a href="#" className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors" data-id="element-117">
                <Linkedin className="h-5 w-5" data-id="element-118" />
                <span data-id="element-119">LinkedIn</span>
              </a>
              <a href="#" className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors" data-id="element-120">
                <Twitter className="h-5 w-5" data-id="element-121" />
                <span data-id="element-122">X</span>
              </a>
              <a href="#" className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors" data-id="element-123">
                <Instagram className="h-5 w-5" data-id="element-124" />
                <span data-id="element-125">Instagram</span>
              </a>
            </div>
          </div>
          <div data-id="element-126">
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase mb-4" data-id="element-127">
              Product
            </h3>
            <ul className="space-y-2" data-id="element-128">
              <li data-id="element-129">
                <a href="#features" className="hover:text-white" data-id="element-130">
                  Features
                </a>
              </li>
              <li data-id="element-131">
                <a href="#how-it-works" className="hover:text-white" data-id="element-132">
                  How It Works
                </a>
              </li>
              <li data-id="element-133">
                <a href="#" className="hover:text-white" data-id="element-134">
                  Pricing
                </a>
              </li>
              <li data-id="element-135">
                <a href="#" className="hover:text-white" data-id="element-136">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-137">
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase mb-4" data-id="element-138">
              Company
            </h3>
            <ul className="space-y-2" data-id="element-139">
              <li data-id="element-140">
                <a href="#" className="hover:text-white" data-id="element-141">
                  About
                </a>
              </li>
              <li data-id="element-142">
                <a href="#" className="hover:text-white" data-id="element-143">
                  Blog
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-slate-800 text-sm text-slate-400" data-id="element-144">
          <div className="flex flex-col md:flex-row justify-between" data-id="element-145">
            <p data-id="element-146">© 2025 TechAIgent. All rights reserved.</p>
            <div className="mt-4 md:mt-0 space-x-6" data-id="element-147">
              <button onClick={() => setIsPolicyOpen(true)} className="hover:text-white transition-colors" data-id="element-148">
                Privacy Policy
              </button>
              <button onClick={() => setIsTermsOpen(true)} className="hover:text-white transition-colors" data-id="element-149">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
      <PolicyModal isOpen={isPolicyOpen} onClose={() => setIsPolicyOpen(false)} title="Privacy Policy" content={privacyContent} data-id="element-150" />
      <PolicyModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Terms of Service" content={termsContent} data-id="element-151" />
    </footer>;
};